import { SelectionMethod } from "building-types/views/SerializableSheetGeometrySelector";
import type { SerializableSheetGeometrySelector } from "building-types/views/SerializableSheetGeometrySelector";
import type { SheetGeometryCategoryTable } from "building-types/views/sheetGeometryCategory";
import { SheetGeometryCategory } from "building-types/views/sheetGeometryCategory";
import type { RelaxationObstacle } from "doc/plans/planGeometrySourceTypes";

const selector: SerializableSheetGeometrySelector = {
  selectionMethod: SelectionMethod.ALL,
};

export const defaultInteractionMap: SheetGeometryCategoryTable<RelaxationObstacle[]> = {
  [SheetGeometryCategory.SLAB_TAG]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINE, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_APPLIANCES, selector },
    { category: SheetGeometryCategory.PROP_FIXTURES, selector },
    { category: SheetGeometryCategory.PROP_FURNITURE, selector },
    { category: SheetGeometryCategory.PROP_OTHER, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINE, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_APPLIANCES, selector },
    { category: SheetGeometryCategory.PROP_FURNITURE, selector },
    { category: SheetGeometryCategory.PROP_OTHER, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.FOUNDATION_DIM_LABEL]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINE, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_APPLIANCES, selector },
    { category: SheetGeometryCategory.PROP_FURNITURE, selector },
    { category: SheetGeometryCategory.PROP_OTHER, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINE, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_APPLIANCES, selector },
    { category: SheetGeometryCategory.PROP_FURNITURE, selector },
    { category: SheetGeometryCategory.PROP_OTHER, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.CASEWORK_TAG]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_APPLIANCES, selector },
    { category: SheetGeometryCategory.PROP_FIXTURES, selector },
    { category: SheetGeometryCategory.PROP_FURNITURE, selector },
    { category: SheetGeometryCategory.PROP_OTHER, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.FLOOR_SYSTEM_TAG]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_APPLIANCES, selector },
    { category: SheetGeometryCategory.PROP_FIXTURES, selector },
    { category: SheetGeometryCategory.PROP_FURNITURE, selector },
    { category: SheetGeometryCategory.PROP_OTHER, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.ROOM_LABELS]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINE, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_APPLIANCES, selector },
    { category: SheetGeometryCategory.PROP_FIXTURES, selector },
    { category: SheetGeometryCategory.PROP_FURNITURE, selector },
    { category: SheetGeometryCategory.PROP_OTHER, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.ELECTRIC_LOAD_LABEL]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINE, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
  [SheetGeometryCategory.PROP_TAG]: [
    { category: SheetGeometryCategory.SECTION_VIEW_CALLOUT, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LABEL, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINE, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.ANNOT_DETAIL, selector },
    { category: SheetGeometryCategory.ANNOT_LINEWORK, selector },
    { category: SheetGeometryCategory.ANNOT_NOTE, selector },
    { category: SheetGeometryCategory.CASEWORK, selector },
    { category: SheetGeometryCategory.CASEWORK_TAG, selector },
    { category: SheetGeometryCategory.COLUMN, selector },
    { category: SheetGeometryCategory.CONDITION_TAG, selector },
    { category: SheetGeometryCategory.DOORS, selector },
    { category: SheetGeometryCategory.DOOR_TAGS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_CONTROLLERS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LINKS, selector },
    { category: SheetGeometryCategory.ELECTRICAL_LOADS, selector },
    { category: SheetGeometryCategory.ELECTRIC_LOAD_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_FRAMING_LABEL, selector },
    { category: SheetGeometryCategory.FLOOR_SYSTEM_TAG, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LABEL, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.FOUNDATION_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.PERIMS_WALL, selector },
    { category: SheetGeometryCategory.FLOOR_HEIGHT_DIFFERENCE, selector },
    { category: SheetGeometryCategory.PROP_TAG, selector },
    { category: SheetGeometryCategory.ROOM_LABELS, selector },
    { category: SheetGeometryCategory.SLAB_TAG, selector },
    { category: SheetGeometryCategory.UTILITY_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_BOUNDARIES, selector },
    { category: SheetGeometryCategory.WALL_CORE, selector },
    { category: SheetGeometryCategory.WALL_FRAMING, selector },
    { category: SheetGeometryCategory.WALL_SUBSTRATE, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_EXTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LABEL, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_LINEWORK, selector },
    { category: SheetGeometryCategory.WALL_INTERIOR_DIM_WITNESS, selector },
    { category: SheetGeometryCategory.WINDOWS, selector },
    { category: SheetGeometryCategory.WINDOW_TAGS, selector },
  ],
};
